import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBModalFooter, MDBRadio, MDBSpinner, MDBTextArea } from "mdb-react-ui-kit";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import { addRole, getMisc } from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../../popups/PopupLoader.js";
import { isEmpty } from "../../validators/helper";
import AddLocation from "./AddLocation";
import PopupLoaderNew from "../PopupLoaderNew.js";


export const AddRole = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();

  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false); // loader image.
  const [allLocations, setAllLocations] = useState(true); // It is a flag to know wheater it is a all locations or specifice location.
  const [internalError, setInternalError] = useState(false);

  const [addLocation, setAddLocation] = useState(false); // It is use to enable the Add location  popup.
  const changeAddLocation = () => setAddLocation(!addLocation);
  const [closingPopup, setClosingPopup] = useState(false); // flag is used to know the child popup is closed.
  const [addedLocations, setAddedLocations] = useState([]); // Newly added locations using add locations button.
  const [existingLocations, setExistingLocations] = useState([]); // Adding the already added locations.
  const [modifedLocations, setModifiedLocations] = useState([]); // Modifed rows data,added delete condition.
  const [allAvailableLocations, setAllAvailableLocations] = useState([]); // All Existing DB Details.
  const addLocRoleRef = useRef(null);
  //const [isLoading, setisLoading] = useState(false);

  function handleClick() {
    addLocRoleRef.current.click();
  }

  const [form, setForm] = useState({
    name: '',
    description: '',
    permissions: {}
  });
  const closeAddAdminRole = (e) => props.onClose(e);

  async function onSubmit(e) {
    setInternalError(false);
    e.preventDefault();
    let validForm = validateFormData();
    if (validForm) {
      try {
        let locationsJSON = { ...(allLocations == true ? { all_locations: true } : { location_ids: existingLocations.map(obj => obj.location_id) }) }
        let additionalInfo = {
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          reqid: 26,
          role: 2,
          locations: locationsJSON,
          logined_user: JSON.parse(sessionStorage.getItem("admin_session")).logined_user
        };
        let finalForm = { ...form, ...additionalInfo };
        setIsLoading(true);
        console.log(`Add Role API json :${JSON.stringify(finalForm)}`);
        let addRoleRes = await addRole(finalForm);
        setIsLoading(false);
        let resInfo = await addRoleRes.json();
        if (addRoleRes.status == 200) {
          if (resInfo.status == 'success') {
            localStorage.setItem("s_message", resInfo.message);
          } else {
            localStorage.setItem("f_message", resInfo.message);
          }
          window.location.href = "/permissionrolessection";
          props.onClose();

        } else if (addRoleRes.status == 400 && resInfo.message?.errors) {
          return validateFormData(resInfo.message?.errors);
        } else {
          localStorage.setItem("f_message", resInfo.message);
          window.location.href = "/permissionrolessection";
          props.onClose();
        }
      } catch (e) {
        console.log(`Unable to process Request ::!`);
        setInternalError(true);
      }
    }
  }

  function validateFormData(errorObj) {
    let errors = {};
    if (errorObj) {// Adding server side errors.
      errorObj.forEach((erObj) => {
        if (erObj.param_name === "logined_user") {
          props.setErrorMessage(erObj.message)
          props.setHasPrevilege(true)
          props.onClose();
        }
        errors[erObj.param_name] = erObj.message;
      });
    }
    else { // client side validation.
      if (isEmpty(form.name)) {
        errors.name = 'Required'
      }
      if (form.permissions) {
        if (Object.values(form.permissions ?? {}).includes(1) == false) {
          errors.permissions = 'At least one permission must be enabled.'
        }
      }
      // Adding mandatory condition for locations.
      if (allLocations == false && existingLocations?.length == 0) {
        errors.location_error = 'At Least one location must be added to create role.';
      }
    }
    if (isEmpty(errors)) {
      return true; // If no errors
    } else {
      if (errors["all_locations,location_ids"]) {
        errors.location_error = errors["all_locations,location_ids"];
      } else if (errors["locations.location_ids"]) {
        errors.location_error = "At Least one location must be added to create role.";
      }

      setError(errors);

    }
    return false;
  }




  function updateForm(changedValue) {
    setError({});
    return setForm((prev) => {
      return { ...prev, ...changedValue };
    });

  }
  function updatePermissions(changedValue) {
    form['permissions'] = { ...form.permissions, ...changedValue };
  }


  const advancedData = {
    columns: [
      { label: "Name", field: "location_name", sort: true },
      { label: "Address", field: "address" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: modifedLocations
  };


  function removeThisLocation(event, location_id) {
    event.preventDefault();
    event.stopPropagation();
    setExistingLocations((prevLocations) => {
      const existedloc = prevLocations.filter(obj => obj.location_id != location_id);
      console.log(`Exisisting Locations::${JSON.stringify(existedloc)}`);
      return existedloc;
    });

    setModifiedLocations((prevModifiedLoc) => {
      const modifiedLoc = prevModifiedLoc.filter(obj => obj.location_id != location_id);
      console.log(`modifiedLoc Locations::${JSON.stringify(modifiedLoc)}`);
      return modifiedLoc;
    });
  }

  //After adding the Add location
  useEffect(() => {
    if (closingPopup == true) {
      setClosingPopup(false);
      //Combing the New Data to existing Data 
      let finalExistingLocations = [...existingLocations, ...addedLocations];
      setExistingLocations([...finalExistingLocations]);
      // framed the rows data in MDBtable .
      let framedRowsInfo = finalExistingLocations.map((infoObj) => ({
        ...infoObj,
        delete: (
          <a
            style={{ zIndex: 99996 }}
            href="#"
            onClick={(e) => removeThisLocation(e, infoObj.location_id)}
            target="_new"
          >
            <MDBIcon fas icon="times" color="primary" title="Remove" />
          </a>
        )
      }));
      setModifiedLocations(framedRowsInfo ?? [])
    }
  }, [closingPopup]);

  // async function getAllLocations() {
  //   const response = await getLocations(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
  //   if (!response.json) {
  //     const message = `An error has occured: ${response.statusText}`;
  //     return;
  //   }
  //   const data = await response.json();
  //   if (!data) {
  //     window.alert(`info with id  not found`);
  //     Navigate("/");
  //   }
  //   setAllAvailableLocations(data.locations);
  // }
  // useEffect(() => {
  //   getAllLocations(); // fetching the locations at the time of add Admin Role.
  // }, []);

  async function getAllLocations() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["all_locations_roles"],
      };

      const response = await getMisc(siteid, params);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      else {
        const data = await response.json();
        if (!data) {
          window.alert(`info with id  not found`);
          Navigate("/");
        }
        console.log("Response Data:", JSON.stringify(data));
        setAllAvailableLocations(data?.misc?.all_locations ?? []);
      }
    } catch (error) {
      console.error("[fetchAllLocations] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  useEffect(() => {
    getAllLocations();

  }, []);



  return (
    <>
      {isLoading && (
        <div>
          <div className="loadingclass-popup"></div>
          <div className="popup-bg-loader loader_align">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />Loading...</MDBBtn>
          </div>
        </div>)}

      {!isLoading && internalError && (<MDBAlert
        open
        className="alert-center"
        color="danger"
        autohide
        position="bottom-right"
        delay={5000}
      >Internal Server Error</MDBAlert>)}


      <div>
        <div className="tel-numbers">
          <strong>{t("name")}</strong>
          <div className="form pt-1">
            <input
              type="text"
              maxLength={50}
              className="w-100"
              onChange={(e) => updateForm({ name: e.target.value })}
            />
            {error.name && (
              <>
                <p style={{ color: "red" }} className="clr-red">
                  {error.name}
                </p>
              </>
            )}
          </div>
        </div>
        <div className="tel-numbers mt-1">
          <strong>{t("Description")}</strong>
          <div className="form pt-1">
            <MDBTextArea
              id="textAreaExample"
              className="w-100"
              rows={2}
              onChange={(e) => updateForm({ description: e.target.value })}
            />
            {error.description && (
              <>
                <p style={{ color: "red" }} className="clr-red">
                  {error.description}
                </p>
              </>
            )}
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className=" d-block">{t("ManageSeats")}</p>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control"
                type="checkbox"
                onChange={(e) => {
                  updatePermissions({ '1': (e.target.checked == true ? 1 : 0) })
                  console.log(`e.target.checked::${e.target.checked}`);
                }}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className=" d-block">
            {t("AddDelEditUsers")}
          </p>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control"
                type="checkbox"
                onChange={(e) => updatePermissions({ '2': (e.target.checked == true ? 1 : 0) })}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className=" d-block">
            {t("Adddeleditaccfeat")}
          </p>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control"
                type="checkbox"
                onChange={(e) => updatePermissions({ '3': (e.target.checked == true ? 1 : 0) })} />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className=" d-block">{t("ManageAdmins")}</p>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control"
                type="checkbox"
                onChange={(e) => updatePermissions({ '4': (e.target.checked == true ? 1 : 0) })}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className=" d-block">
            {t("Accessuserdatareports")}
          </p>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control"
                type="checkbox"
                onChange={(e) => updatePermissions({ '5': (e.target.checked == true ? 1 : 0) })}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className=" d-block">
            {t("Accessusercallrec")}
          </p>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control"
                type="checkbox"
                onChange={(e) => updatePermissions({ '6': (e.target.checked == true ? 1 : 0) })}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className=" d-block">
            {t("AdddeleditPermissionRoles")}
          </p>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control"
                type="checkbox"
                onChange={(e) => updatePermissions({ '7': (e.target.checked == true ? 1 : 0) })}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <p className=" d-block">
            {t("Accessbillingsect")}
          </p>
          <div className="phoneselect">
            <label className="switch">
              <input className="form-control"
                type="checkbox"
                onChange={(e) => updatePermissions({ '8': (e.target.checked == true ? 1 : 0) })}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        {error.permissions && (
          <>
            <p style={{ color: "red" }} className="clr-red">
              {error.permissions}
            </p>
          </>
        )}

        <div className="tel-numbers mt-2 ">
          <p className=" d-block">{t("location")}</p>
          <div className="d-flex mt-2">
            <MDBRadio
              name="inlineRadio"
              id="inlineRadio1"
              value="option1"
              label="All Locations"
              inline
              checked={allLocations}
              onChange={() => setAllLocations(true)}
            />
            <MDBRadio
              name="inlineRadio"
              id="inlineRadio2"
              value="option2"
              label="Select Location"
              inline
              checked={!allLocations}
              onChange={() => setAllLocations(false)}
            />
          </div>
        </div>
        {allLocations == false && (
          <>
            <div className=" mt-2 d-flex justify-content-end w-100">
              <MDBBtn
                className="green-button "
                data-mdb-toggle="modal"
                data-mdb-target="#exampleModal"
                onClick={changeAddLocation}
              >
                <MDBIcon fas icon="plus" size="sm" /> {t("addlocation")}
              </MDBBtn>
            </div>
            {/* error setting for locations. */}
            {error.location_error && (
              <>
                <p style={{ color: "red" }} className="clr-red">
                  {error.location_error}
                </p>
              </>
            )}
            <div className="permissionRoleDataTable">

              <MDBDatatable sortField="Name"
                data={advancedData}
                pagination={false}
                fixedHeader
                entries={100000}
                className="mt-2 actioncolumn"
              />
            </div>
          </>
        )}


        {addLocation && (
          <PopupLoaderNew
            // size="lg"
            // className="modal-lg"
            title="Add Location"
            content={<AddLocation
              onClose={changeAddLocation}
              closingPopup={setClosingPopup}
              existingLocations={existingLocations}
              setAddedLocations={setAddedLocations}
              allLocations={allAvailableLocations}
              ref={addLocRoleRef}
              setIsloading={props.setisLoading}
            />}
            onShow={setAddLocation}
            onClose={changeAddLocation}
            onSave={handleClick}
            isloading={isLoading}
            flag={1}
          />
        )}

      </div>

      <div style={{ display: "none" }}>
        <button ref={ref} onClick={onSubmit}>
          {t("add")}</button>
      </div>

      {/* <MDBModalFooter>
        <MDBBtn color="secondary" onClick={closeAddAdminRole}>
          {t("close")}
        </MDBBtn>
        <MDBBtn onClick={onSubmit} >{t("add")}</MDBBtn>
      </MDBModalFooter> */}



    </>

  );
});